import React, { useState } from "react";
import "react-responsive-modal/styles.css";
import { Spinner, Title } from "../../atoms";
import { Modal } from "react-responsive-modal";
import T from "prop-types";

const PartialOrderAcceptanceModal = ({
  open,
  selectedOrder,
  title,
  content,
  contentDetail,
  subContent,
  onConfirm,
  onCancel,
  rightBtnText,
  titleIcon,
  cancelText,
  titleClass,
  isLoading,
}) => {
  const [selectedOptions, setSelectedOptions] = useState("all");
  const { lineItems = [] } = selectedOrder;
  return (
    <Modal open={open} showCloseIcon={false} center onClose={onCancel}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (selectedOptions === "all") {
            onConfirm({ orderId: selectedOrder.orderId, acceptAll: true, lineItemIds:lineItems.map(item => item.id) });
          } else {
            onConfirm({
              orderId: selectedOrder.orderId,
              acceptAll: false,
              lineItemIds: selectedOptions.map((opt) => Number(opt)),
            });
          }
        }}
      >
        {lineItems.length === 1 ? (
          <div>
            <div className="boxImgDiv">
              <img src={titleIcon} />
              <Title text={title} className={titleClass} />
            </div>
            <Title text={content} className="boxContent" />
            {contentDetail && (
              <Title text={contentDetail} className="boxContent" />
            )}
            <Title text={subContent} className="boxContent" />
          </div>
        ) : (
          <div>
            <div className="text">
              <input
                type="radio"
                value="all"
                checked={selectedOptions === "all"}
                onChange={(e) => setSelectedOptions(e.target.value)}
              />{" "}
              Accept (all items)
            </div>
            {lineItems.map((lineItem) => (
              <div className="text">
                <input
                  type="radio"
                  value={lineItem.id}
                  checked={selectedOptions?.includes(lineItem.id.toString())}
                  onChange={(e) =>
                    setSelectedOptions(
                      selectedOptions === "all"
                        ? [e.target.value]
                        : [...selectedOptions, e.target.value]
                    )
                  }
                />
                {lineItem.name}
              </div>
            ))}
          </div>
        )}
        <div
          style={{
            display: "flex",
            marginTop: 20,
            justifyContent: "space-around",
          }}
        >
          <button type="button" onClick={onCancel} className="boxCancelBtn text">
            {cancelText}
          </button>
          {isLoading ? (
            <div className="spinnerContainer">
              <Spinner color={"black"} loading={isLoading} size={20} />
            </div>
          ) : (
            <button type="submit" className="boxDelBtn text" id="para1">
              {rightBtnText}
            </button>
          )}
        </div>
      </form>
    </Modal>
  );
};

PartialOrderAcceptanceModal.T = {
  onConfirm: T.func,
  onCancel: T.func,
  content: T.string,
  cancelText: T.string,
  titleClass: T.string,
};

export default PartialOrderAcceptanceModal;
